const GROUPS = [
  {
    title: '板块导航',
    items: [
      { label: '实时热榜', href: '#hot' },
      { label: '上升最快', href: '#rising' },
      { label: '瓜田分类', href: '#category' },
      { label: '深度吃瓜', href: '#deep' },
    ],
  },
  {
    title: '站点帮助',
    items: [
      { label: '常见问题', href: '#faq' },
      { label: '关于快瓜', href: '#about' },
      { label: '订阅瓜讯', href: '#subscribe' },
      { label: '返回顶部', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-12 pb-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-background-50 text-primary-600">
                <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-xl font-bold text-background-50">快瓜</span>
                <span className="block text-[10px] font-medium uppercase tracking-[0.18em] text-background-100/60">
                  Gua Radar
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              快瓜是面向年轻网民的全网热榜聚合与吃瓜资讯站。紧盯全网热门飙升话题，
              爆瓜预警第一时间触发，帮你追平热榜、看懂舆论风向。
            </p>
            <div className="mt-5 flex items-center gap-2 text-background-100/70" aria-label="联系我们">
              <i className="ri-mail-line" aria-hidden="true"></i>
              <a href="mailto:hello@kuagua.top" className="text-sm transition hover:text-background-50" rel="nofollow">
                hello@kuagua.top
              </a>
            </div>
          </div>

          {GROUPS.map((g) => (
            <div key={g.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{g.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it) => (
                  <li key={it.label}>
                    <a
                      href={it.href}
                      className="text-sm text-background-100/75 transition hover:text-accent-300"
                    >
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">追更工具</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              关注快瓜，用最快的方式跟上每一次舆论风向，不错过任何一颗正在飙升的瓜。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {[
                { icon: 'ri-twitter-x-line', label: 'X 平台' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-chat-3-line', label: '社区' },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 cursor-default items-center justify-center rounded-full border border-background-100/25 text-background-100/80 transition hover:border-accent-300 hover:text-accent-300"
                >
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/20 pt-5 text-xs text-background-100/60 sm:flex-row">
          <p>© 2026 快瓜 Gua Radar · 只为更快看懂每一次热门飙升</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            理性吃瓜 · 不信谣不传谣
          </p>
        </div>
      </div>
    </footer>
  );
}